import Modal from "./Modal";

const defaultDescription =
  "Provide coaching tips or feedback for this drill to help athletes improve their performance.";

export default function CoachingTipsModal({
  isOpen,
  isEditing = false,
  title,
  description = defaultDescription,
  coachingTip,
  coachingTipError = "",
  isSaving = false,
  readOnly = false,
  onClose,
  onChange,
  onSubmit,
}) {
  const modalTitle = title || (isEditing ? "Edit Tips" : "Add Tips");
  const textareaClassName = readOnly
    ? "w-full resize-none p-0 text-base text-gray-800"
    : "w-full resize-none rounded-md border border-gray-300 px-4 py-3 text-base text-gray-700";

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!readOnly) {
      onSubmit?.(event);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      contentClassName="bg-white rounded-md shadow-2xl w-full max-w-2xl p-0 relative"
    >
      <form onSubmit={handleSubmit} className="p-6">
        <h2 className="text-2xl font-semibold text-black">{modalTitle}</h2>
        {description && (
          <p className="mt-1 text-base text-black">{description}</p>
        )}

        <div className="mt-4">
          <textarea
            value={coachingTip}
            onChange={(event) => onChange?.(event.target.value)}
            placeholder="Enter your coaching tips here..."
            rows={7}
            readOnly={readOnly}
            className={textareaClassName}
          />
          {coachingTipError && (
            <p className="mt-2 text-sm text-red-500">{coachingTipError}</p>
          )}
        </div>

        <div className="mt-4 flex justify-end gap-4">
          <button
            type="button"
            onClick={onClose}
            disabled={isSaving}
            className="rounded border border-gray-300 px-8 py-3 text-sm font-medium text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {readOnly ? "Close" : "Cancel"}
          </button>
          {!readOnly && (
            <button
              type="submit"
              disabled={isSaving}
              className="rounded bg-red-600 px-8 py-3 text-sm font-medium text-white transition hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
            >
              {isSaving ? "Saving..." : "Save"}
            </button>
          )}
        </div>
      </form>
    </Modal>
  );
}
